import { z } from "zod";

export const requestSchema = z.object({
  id: z.number(),
  source_type: z.string(),
  source_id: z.number(),
  type: z.string(),
  invoice_status: z.string().optional().nullable(),
  relation: z.object({
    id: z.string(),
    name: z.string(),
  }),
  state: z.string(),
  work_order_number: z.string(),
  pickup_and_delivery_date: z.string(),
  in_out_storage: z.string(),
  updated_at: z.string(),
  freestock: z.boolean(),
  requestTires: z.object({
    id: z.number(),
    tire: z.object({
      id: z.number(),
      brand: z.string(),
      car_position: z.string(),
      ean: z.string(),
      label: z.string(),
    }),
  }),
  source: z.object({
    "... on Tire": z.object({
      id: z.string(),
      brand: z.string(),
    }),
    "... on Tireset": z.object({
      id: z.string(),
      type: z.string(),
      sleep_set: z.boolean(),
      car: z.object({
        id: z.string(),
        licence: z.string(),
        label: z.string(),
        additional_info: z.string(),
      }),
      position: z.object({
        id: z.string(),
        label: z.string(),
      }),
    }),
  }),
});
